import React from 'react';
import parse from 'html-react-parser';

//Redux
import { useSelector } from 'react-redux';

//Bootstrap
import { Container, Row } from 'react-bootstrap';

//FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faPhoneAlt, faMapMarkerAlt, faDownload } from '@fortawesome/free-solid-svg-icons';

import './SobreMi.css';
import InfoCustomCard from '../../../components/InfoCustomCard/InfoCustomCard';
import ProgressBar from '../../../components/ProgressBar/ProgressBar';
import SocialButtons from '../../../components/SocialButtons/SocialButtons';
import Timeline from '../../../components/Timeline/Timeline';

const iconArr = [faLinkedin, faEnvelope, faPhoneAlt, faMapMarkerAlt];

const SobreMi = () => {
    const personalInfo = useSelector(state => state.data.personalInfo);
    const socialNetwork = useSelector(state => state.data.socialNetworks);
    const skills = useSelector(state => state.data.skills);
    const lenguages = useSelector(state => state.data.lenguages);
    const experience = useSelector(state => state.data.experience);
    const education = useSelector(state => state.data.education);

    const contactInfo = personalInfo ?
        [
            { id: personalInfo[6].ID, value: decodeURIComponent(personalInfo[6].VALOR), icon: decodeURIComponent(personalInfo[6].TITULO_LABEL_HTML), href: decodeURIComponent(personalInfo[6].HREF) },
            { id: personalInfo[7].ID, value: decodeURIComponent(personalInfo[7].VALOR), icon: decodeURIComponent(personalInfo[7].TITULO_LABEL_HTML), href: decodeURIComponent(personalInfo[7].HREF) },
            { id: personalInfo[13].ID, value: decodeURIComponent(personalInfo[13].VALOR), icon: decodeURIComponent(personalInfo[13].TITULO_LABEL_HTML), href: decodeURIComponent(personalInfo[13].HREF) },
            { id: personalInfo[8].ID, value: decodeURIComponent(personalInfo[8].VALOR), icon: decodeURIComponent(personalInfo[8].TITULO_LABEL_HTML), href: null }
        ] : null;

    const aboutMe = personalInfo ? parse(decodeURIComponent(personalInfo[9].VALOR)) : null;
    const cv = personalInfo ? `./assets/docs/${parse(decodeURIComponent(personalInfo[16].VALOR))}` : null;
    return (
        <Container fluid className="px-sm-5 px-3 py-5 text-center">
            <SocialButtons data={socialNetwork} />
            <Row className="px-5 py-4 justify-content-around text-align-center text-left">
                <InfoCustomCard id="about" title="Acerca de mí" classes="my-3 my-md-0" flex={{ md: "5" }}>
                    {aboutMe}
                </InfoCustomCard>
                <InfoCustomCard id="info" title="Información / Contacto" classes="my-3 my-md-0" flex={{ md: "5" }}>
                    {contactInfo ?
                        contactInfo.map(s => {
                            const icon = iconArr.find(i => i.iconName === s.icon);
                            return <p key={s.id} className="custom-description d-flex align-items-center py-2 text-break">
                                <FontAwesomeIcon icon={icon} className="mr-4 custom-social-info" />
                                {s.href ?
                                    <a className="custom-normal-link" href={s.href} target="_blank" rel="noopener noreferrer">
                                        {s.value}
                                    </a>
                                    :
                                    <React.Fragment>{s.value}</React.Fragment>
                                }
                            </p>
                        })
                        :
                        null
                    }

                    <a href={cv} target="_blank" rel="noopener noreferrer" className="btn custom-btn px-sm-4 py-sm-3 px-3 py-2 mt-4 mb-3"><FontAwesomeIcon icon={faDownload} className="mr-2" />Descargar CV</a>
                </InfoCustomCard>
            </Row>
            <Row className="px-5 py-4 justify-content-center text-align-center text-left">
                <InfoCustomCard id="skills" title="Skills Profesionales" classes="text-center">
                    {skills ? skills.map(s => <ProgressBar key={s.ID} value={s.VALOR} id={decodeURIComponent(s.NOMBRE_ITEM)} name={decodeURIComponent(s.NOMBRE_ITEM)} />) : null}
                </InfoCustomCard>
            </Row>
            {experience ? <Timeline title="Experiencia laboral" data={experience} /> : null}
            {education ? <Timeline title="Educación" data={education} /> : null}
            <Row className="px-5 py-4 justify-content-center text-align-center text-left">
                <InfoCustomCard id="skills" title="Idiomas" classes="text-center">
                    {lenguages ? lenguages.map(s => <ProgressBar key={s.ID} value={s.VALOR} id={decodeURIComponent(s.NOMBRE_ITEM)} name={decodeURIComponent(s.NOMBRE_ITEM)} />) : null}
                </InfoCustomCard>
            </Row>
        </Container>
    );
};

export const componentName = "SobreMi";
export default SobreMi;